/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/shared/list-card/list-card.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@ngx-translate/core/src/translate.pipe';
import * as import10 from '@angular/core/src/linker/view_container';
import * as import11 from '@ngx-translate/core/src/translate.service';
import * as import12 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import13 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import14 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import15 from '@angular/core/src/linker/element_ref';
import * as import16 from '@angular/common/src/directives/ng_class';
import * as import17 from '@angular/core/src/linker/query_list';
import * as import18 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import19 from '../../../../node_modules/@angular/common/src/directives/ng_style.ngfactory';
import * as import20 from '@angular/core/src/linker/template_ref';
import * as import21 from '@angular/common/src/directives/ng_if';
import * as import22 from '@angular/common/src/directives/ng_style';
export class Wrapper_ListCardComponent {
  /*private*/ _eventHandler:Function;
  context:import0.ListCardComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  subscription0:any;
  subscription1:any;
  constructor(p0:any) {
    this._changed = false;
    this.context = new import0.ListCardComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
    (this.subscription1 && this.subscription1.unsubscribe());
  }
  check_listCard(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.listCard = currValue;
      this._expr_0 = currValue;
    }
  }
  check_cardHeight(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.cardHeight = currValue;
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean,emit1:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.remove.subscribe(_eventHandler.bind(view,'remove'))); }
    if (emit1) { (this.subscription1 = this.context.edit.subscribe(_eventHandler.bind(view,'edit'))); }
  }
}
var renderType_ListCardComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_ListCardComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.ListCardComponent>;
  _ListCardComponent_0_3:Wrapper_ListCardComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ListCardComponent_Host0,renderType_ListCardComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'list-card',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_ListCardComponent0(this.viewUtils,this,0,this._el_0);
    this._ListCardComponent_0_3 = new Wrapper_ListCardComponent(this.compView_0.ref);
    this.compView_0.create(this._ListCardComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._ListCardComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ListCardComponent) && (0 === requestNodeIndex))) { return this._ListCardComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ListCardComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { this._ListCardComponent_0_3.context.ngAfterViewChecked(); }
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._ListCardComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 0) && (ngContentIndex == 0))) {  }
  }
}
export const ListCardComponentNgFactory:import8.ComponentFactory<import0.ListCardComponent> = new import8.ComponentFactory<import0.ListCardComponent>('list-card',View_ListCardComponent_Host0,import0.ListCardComponent);
const styles_ListCardComponent:any[] = ([] as any[]);
class View_ListCardComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  /*private*/ _expr_15:any;
  _pipe_translate_0:import9.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_ListCardComponent1,renderType_ListCardComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_15 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','card-icon-container eva-3-tooltip  -top -right -sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','message-icon eva-3-icon-edit'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','tooltip-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'i',new import3.InlineArray2(2,'class','tooltip-marker'),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_4,'span',new import3.InlineArray2(2,'class','tooltip-content'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                            ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'p',new import3.InlineArray2(2,'class','tooltip-text'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                        ',(null as any));
    this._text_13 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    this._pipe_translate_0 = new import9.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_15:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.EDIT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_15,currVal_15))) {
      this.renderer.setText(this._text_11,currVal_15);
      this._expr_15 = currVal_15;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.editCallback()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_ListCardComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  /*private*/ _expr_15:any;
  _pipe_translate_0:import9.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_ListCardComponent2,renderType_ListCardComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_15 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','card-icon-container eva-3-tooltip  -top -right -sm -eva-3-fr'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','message-icon eva-3-icon-trash'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','tooltip-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'i',new import3.InlineArray2(2,'class','tooltip-marker'),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_4,'span',new import3.InlineArray2(2,'class','tooltip-content'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                            ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'p',new import3.InlineArray2(2,'class','tooltip-text'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                        ',(null as any));
    this._text_13 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    this._pipe_translate_0 = new import9.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_15:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.REMOVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_15,currVal_15))) {
      this.renderer.setText(this._text_11,currVal_15);
      this._expr_15 = currVal_15;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.removeCallback()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_ListCardComponent3 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _NgClass_7_3:import12.Wrapper_NgClass;
  _text_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _NgClass_15_3:import12.Wrapper_NgClass;
  _text_16:any;
  _text_17:any;
  /*private*/ _expr_20:any;
  /*private*/ _expr_21:any;
  _pipe_translate_0:import9.TranslatePipe;
  _map_23:any;
  /*private*/ _expr_24:any;
  /*private*/ _expr_25:any;
  _pipe_translate_1:import9.TranslatePipe;
  _map_27:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_ListCardComponent3,renderType_ListCardComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_20 = import1.UNINITIALIZED;
    this._expr_21 = import1.UNINITIALIZED;
    this._map_23 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'glyphicon-chevron-up': p0};
    });
    this._expr_24 = import1.UNINITIALIZED;
    this._expr_25 = import1.UNINITIALIZED;
    this._map_27 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'glyphicon-chevron-down': p0};
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','panel-footer'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','arrow-btn glyphicon'),(null as any));
    this._NgClass_7_3 = new import12.Wrapper_NgClass(this.parentView.parentView.injectorGet(import13.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import14.KeyValueDiffers,this.parentView.parentIndex),new import15.ElementRef(this._el_7),this.renderer);
    this._text_8 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_0,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_10,'i',new import3.InlineArray2(2,'class','arrow-btn glyphicon'),(null as any));
    this._NgClass_15_3 = new import12.Wrapper_NgClass(this.parentView.parentView.injectorGet(import13.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import14.KeyValueDiffers,this.parentView.parentIndex),new import15.ElementRef(this._el_15),this.renderer);
    this._text_16 = this.renderer.createText(this._el_10,'\n        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    this._pipe_translate_0 = new import9.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_10,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_10));
    this._pipe_translate_1 = new import9.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import16.NgClass) && (7 === requestNodeIndex))) { return this._NgClass_7_3.context; }
    if (((token === import16.NgClass) && (15 === requestNodeIndex))) { return this._NgClass_15_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_7_0_0:any = 'arrow-btn glyphicon';
    this._NgClass_7_3.check_klass(currVal_7_0_0,throwOnChange,false);
    const currVal_7_0_1:any = this._map_23(!this.parentView.context.collapsed);
    this._NgClass_7_3.check_ngClass(currVal_7_0_1,throwOnChange,false);
    this._NgClass_7_3.ngDoCheck(this,this._el_7,throwOnChange);
    const currVal_15_0_0:any = 'arrow-btn glyphicon';
    this._NgClass_15_3.check_klass(currVal_15_0_0,throwOnChange,false);
    const currVal_15_0_1:any = this._map_27(this.parentView.context.collapsed);
    this._NgClass_15_3.check_ngClass(currVal_15_0_1,throwOnChange,false);
    this._NgClass_15_3.ngDoCheck(this,this._el_15,throwOnChange);
    const currVal_20:any = this.parentView.context.collapsed;
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementProperty(this._el_2,'hidden',currVal_20);
      this._expr_20 = currVal_20;
    }
    valUnwrapper.reset();
    const currVal_21:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.VIEW_LESS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_21,currVal_21))) {
      this.renderer.setText(this._text_5,currVal_21);
      this._expr_21 = currVal_21;
    }
    const currVal_24:boolean = !this.parentView.context.collapsed;
    if (import3.checkBinding(throwOnChange,this._expr_24,currVal_24)) {
      this.renderer.setElementProperty(this._el_10,'hidden',currVal_24);
      this._expr_24 = currVal_24;
    }
    valUnwrapper.reset();
    const currVal_25:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('common.VIEW_MORE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_25,currVal_25))) {
      this.renderer.setText(this._text_13,currVal_25);
      this._expr_25 = currVal_25;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.collapsed = !this.parentView.context.collapsed)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_10(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.collapsed = !this.parentView.context.collapsed)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_ListCardComponent:import4.RenderComponentType = import3.createRenderComponentType('',1,import5.ViewEncapsulation.None,styles_ListCardComponent,{});
export class View_ListCardComponent0 extends import2.AppView<import0.ListCardComponent> {
  _viewQuery_content_0:import17.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _anchor_14:any;
  /*private*/ _vc_14:import10.ViewContainer;
  _TemplateRef_14_5:any;
  _NgIf_14_6:import18.Wrapper_NgIf;
  _text_15:any;
  _anchor_16:any;
  /*private*/ _vc_16:import10.ViewContainer;
  _TemplateRef_16_5:any;
  _NgIf_16_6:import18.Wrapper_NgIf;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _NgStyle_21_3:import19.Wrapper_NgStyle;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _anchor_25:any;
  /*private*/ _vc_25:import10.ViewContainer;
  _TemplateRef_25_5:any;
  _NgIf_25_6:import18.Wrapper_NgIf;
  _text_26:any;
  /*private*/ _expr_38:any;
  _map_39:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ListCardComponent0,renderType_ListCardComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_38 = import1.UNINITIALIZED;
    this._map_39 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        height: p0,
        overflow: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_content_0 = new import17.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','panel panel-default card-panel'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray4(4,'class','panel-heading','style','padding-top: 0px;padding-bottom: 0px;'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','reset-styles eva-3-row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','-md-10 no-overflow'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'span',new import3.InlineArray4(4,'class','title ellipsisText -eva-3-pt-md -eva-3-pb-sm','qadata','name'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray4(4,'class','-md-2','style','text-align: right'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._anchor_14 = this.renderer.createTemplateAnchor(this._el_12,(null as any));
    this._vc_14 = new import10.ViewContainer(14,12,this,this._anchor_14);
    this._TemplateRef_14_5 = new import20.TemplateRef_(this,14,this._anchor_14);
    this._NgIf_14_6 = new import18.Wrapper_NgIf(this._vc_14.vcRef,this._TemplateRef_14_5);
    this._text_15 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._anchor_16 = this.renderer.createTemplateAnchor(this._el_12,(null as any));
    this._vc_16 = new import10.ViewContainer(16,12,this,this._anchor_16);
    this._TemplateRef_16_5 = new import20.TemplateRef_(this,16,this._anchor_16);
    this._NgIf_16_6 = new import18.Wrapper_NgIf(this._vc_16.vcRef,this._TemplateRef_16_5);
    this._text_17 = this.renderer.createText(this._el_12,'\n            ',(null as any));
    this._text_18 = this.renderer.createText(this._el_4,'\n\n        ',(null as any));
    this._text_19 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_20 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_0,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgStyle_21_3 = new import19.Wrapper_NgStyle(this.parentView.injectorGet(import14.KeyValueDiffers,this.parentIndex),new import15.ElementRef(this._el_21),this.renderer);
    this._text_22 = this.renderer.createText(this._el_21,'\n        ',(null as any));
    this.projectNodes(this._el_21,0);
    this._text_23 = this.renderer.createText(this._el_21,'\n    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._anchor_25 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_25 = new import10.ViewContainer(25,0,this,this._anchor_25);
    this._TemplateRef_25_5 = new import20.TemplateRef_(this,25,this._anchor_25);
    this._NgIf_25_6 = new import18.Wrapper_NgIf(this._vc_25.vcRef,this._TemplateRef_25_5);
    this._text_26 = this.renderer.createText(this._el_0,'\n\n',(null as any));
    this._viewQuery_content_0.reset([new import15.ElementRef(this._el_21)]);
    this.context.content = this._viewQuery_content_0.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._anchor_14,
      this._text_15,
      this._anchor_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._anchor_25,
      this._text_26
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.TemplateRef) && (14 === requestNodeIndex))) { return this._TemplateRef_14_5; }
    if (((token === import21.NgIf) && (14 === requestNodeIndex))) { return this._NgIf_14_6.context; }
    if (((token === import20.TemplateRef) && (16 === requestNodeIndex))) { return this._TemplateRef_16_5; }
    if (((token === import21.NgIf) && (16 === requestNodeIndex))) { return this._NgIf_16_6.context; }
    if (((token === import22.NgStyle) && ((21 <= requestNodeIndex) && (requestNodeIndex <= 23)))) { return this._NgStyle_21_3.context; }
    if (((token === import20.TemplateRef) && (25 === requestNodeIndex))) { return this._TemplateRef_25_5; }
    if (((token === import21.NgIf) && (25 === requestNodeIndex))) { return this._NgIf_25_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_14_0_0:any = this.context.listCard.editable;
    this._NgIf_14_6.check_ngIf(currVal_14_0_0,throwOnChange,false);
    this._NgIf_14_6.ngDoCheck(this,this._anchor_14,throwOnChange);
    const currVal_16_0_0:any = this.context.listCard.removable;
    this._NgIf_16_6.check_ngIf(currVal_16_0_0,throwOnChange,false);
    this._NgIf_16_6.ngDoCheck(this,this._anchor_16,throwOnChange);
    const currVal_21_0_0:any = this._map_39((this.context.collapsed? (this.context.cardHeight + 'px'): 'inherit'),'hidden');
    this._NgStyle_21_3.check_ngStyle(currVal_21_0_0,throwOnChange,false);
    this._NgStyle_21_3.ngDoCheck(this,this._el_21,throwOnChange);
    const currVal_25_0_0:any = this.context.showMoreButtons();
    this._NgIf_25_6.check_ngIf(currVal_25_0_0,throwOnChange,false);
    this._NgIf_25_6.ngDoCheck(this,this._anchor_25,throwOnChange);
    this._vc_14.detectChangesInNestedViews(throwOnChange);
    this._vc_16.detectChangesInNestedViews(throwOnChange);
    this._vc_25.detectChangesInNestedViews(throwOnChange);
    const currVal_38:any = import3.inlineInterpolate(1,'',this.context.listCard.title,'');
    if (import3.checkBinding(throwOnChange,this._expr_38,currVal_38)) {
      this.renderer.setText(this._text_9,currVal_38);
      this._expr_38 = currVal_38;
    }
  }
  destroyInternal():void {
    this._vc_14.destroyNestedViews();
    this._vc_16.destroyNestedViews();
    this._vc_25.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 14)) { return new View_ListCardComponent1(this.viewUtils,this,14,this._anchor_14,this._vc_14); }
    if ((nodeIndex == 16)) { return new View_ListCardComponent2(this.viewUtils,this,16,this._anchor_16,this._vc_16); }
    if ((nodeIndex == 25)) { return new View_ListCardComponent3(this.viewUtils,this,25,this._anchor_25,this._vc_25); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/shared/list-card/list-card.component.ngfactory.ts